import { CORPORATE } from 'services/shared/imageService';

export const POSTS = [
	{
		slug: 'how-to-convert-image-to-video-with-ai',
		title: 'How to convert image to video with AI',
		excerpt:
			'A practical walkthrough for turning a single product photo into a cinematic video — prompts, ratios, and the small details that make output feel premium.',
		category: 'Tutorial',
		readTime: '8 min read',
		date: 'May 28, 2026',
		author: 'The imagemotion team',
		cover: CORPORATE.PANDA,
	},
	{
		slug: 'how-to-convert-text-to-image-with-ai',
		title: 'How to convert text to image with AI',
		excerpt:
			'Turning words into visuals: a guide to mastering the art of the prompt for ai image generation to create photorealistic results.',
		category: 'Tutorial',
		readTime: '12 min read',
		date: 'June 03, 2026',
		author: 'The imagemotion team',
		cover: CORPORATE.PRODUCTIMAGE_TEXT_TO_IMAGE,
	},
	// {
	// 	slug: 'how-to-sharpen-a-video-with-ai-upscaling',
	// 	title: 'How to sharpen a video with AI upscaling',
	// 	excerpt: 'Recovering detail from low-res footage and preparing your exports for 4K displays.',
	// 	category: 'Product',
	// 	readTime: '5 min read',
	// 	date: 'June 08, 2026',
	// 	author: 'The imagemotion team',
	// 	cover: CORPORATE.PRODUCTIMAGE_VIDEO_UPSCALER,
	// },
	// {
	// 	slug: 'voice-to-image-how-ai-turns-your-words-into-art',
	// 	title: 'Voice to image: how AI turns your words into art',
	// 	excerpt: 'The future of hands-free creation. How the voice-to-canvas pipeline is changing the creative process.',
	// 	category: 'Product',
	// 	readTime: '7 min read',
	// 	date: 'June 14, 2026',
	// 	author: 'The imagemotion team',
	// 	cover: CORPORATE.PRODUCTIMAGE_VOICE_TO_IMAGE,
	// },
	// {
	// 	slug: 'anatomy-of-a-scroll-stopping-ad',
	// 	title: 'The anatomy of a scroll-stopping ad',
	// 	excerpt: 'Why the first 0.6 seconds decide everything, and how to engineer them on purpose.',
	// 	category: 'Craft',
	// 	readTime: '6 min read',
	// 	date: 'May 12, 2026',
	// 	author: 'Editorial',
	// 	cover: AD.NIKE_AD,
	// },
	// {
	// 	slug: 'character-consistency-with-ai-avatars',
	// 	title: 'Character consistency with AI avatars',
	// 	excerpt: 'How the @name system keeps a face, a tone and a wardrobe locked across hundreds of generations.',
	// 	category: 'Product',
	// 	readTime: '5 min read',
	// 	date: 'Apr 28, 2026',
	// 	author: 'Studio',
	// 	cover: CORPORATE.CHARACTER_BMW_HOLLYWOOD,
	// },
	// {
	// 	slug: 'ratios-that-convert',
	// 	title: 'Ratios that convert: a creative\'s cheat sheet',
	// 	excerpt: '9:16 vs 1:1 vs 4:5 — when to use each, and the framing rules nobody teaches.',
	// 	category: 'Performance',
	// 	readTime: '4 min read',
	// 	date: 'Apr 14, 2026',
	// 	author: 'Editorial',
	// 	cover: CORPORATE.REAL_AI_CARDS,
	// },
];
